<template>
  <div v-if="messages && messages.length">
    <h5 class="mt-0">
      Messages
    </h5>

    <div
      v-for="message in messages"
      :key="message.id"
      class="media-body mb-3 media-success"
    >
      <div class="mb-1 text-dark">
        <small>{{ message.created_at }}</small>
      </div>
      <div class="text-dark messageBody">
        <p v-html="message.body" />
      </div>
    </div>
  </div>
</template>

<script>
import ServiceTls from "@/services/ServiceTls";

const data = () =>({
	messages: []
});

const fetchMessages = function () {
	ServiceTls.Messages.all(this.caseId).then(response => {
		if (response.messages) {
			this.messages = response.messages;
		}
	});
};

const refresh = fetchMessages;

export default {
	name: "MessagesList",
	props: {
		caseId: {
			type: String,
			required: true
		}
	},
	data,
	watch: {
		"caseId": "fetchMessages"
	},
	mounted() {
		this.fetchMessages();
	},
	methods: {
		refresh,
		fetchMessages
	}
};
</script>
